import $ from 'jquery'

import { trackEvent } from './utils/analytics'

const recentlyTracked = {}

export function init() {
  // Open external links and PDFs in new window
  $(document).on('click', 'a, area', function () {
    const href = $(this).attr('href')
    if (
      href &&
      !this.target &&
      ((href.indexOf(window.location.hostname) == -1 && href.match(/^https?/i)) || href.match(/\.(pdf|docx?|xlsx?)$/i))
    ) {
      this.target = '_blank'
    }
  })

  // Track all file accesses
  $('[data-filename]').on('click', function () {
    const href = $(this).attr('data-filename')
    if (href) {
      trackEvent('Website', 'Download', href)
    }
  })

  // Track document links
  $(document).on('click', 'a, area', function () {
    const href = $(this).attr('data-filename') || $(this).attr('href')
    if (href && href.match(/\.(pdf|docx?|xlsx?)$/i)) {
      trackEvent('Website', 'DocumentLink', href)
    }
  })

  // Track toolbox tile link
  $(document).on('click', 'a.toolbox-tile', function (event) {
    const tileTitle = $(this).find('.toolbox-tile-label').text()

    if (tileTitle && !recentlyTracked[tileTitle]) {
      trackEvent('Website', 'ToolboxTile', tileTitle)
    }
    recentlyTracked[tileTitle] = true
    setTimeout(() => (recentlyTracked[tileTitle] = false), 1000)
  })
}
